import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/what-we-ship.jpg'),
    alt: 'what we ship page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'what we ship page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'A Reliable <span>Shipping Solution</span> <span>For All Your Needs</span>',
  description:
    'ShipAndStorage provides secure and affordable shipping for luggage, sports equipment, specialty items, and household goods, ensuring hassle-free service.',
  image: {
    url: '/images/v2/pages/main-pages/what-we-ship/hero-image.jpg',
    alt: 'what we ship page'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Shipping Quote' }
}

export const serviceTipsSectionContent = {
  title: 'How It Works',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Now' },

  cards: [
    {
      id: 1,
      title: 'Book Your Shipment',
      description: 'Schedule a fast shipment with our easy-to-use online booking system.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/book-your-shipment.svg',
        alt: 'Book Your Shipment service'
      }
    },
    {
      id: 2,
      title: 'Attach Your Labels',
      description: 'Secure the provided shipping labels for your items for smooth processing.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/attach-your-labels.svg',
        alt: 'Attach Your Labels service'
      }
    },
    {
      id: 3,
      title: 'We Ship It for You',
      description: 'We manage pickup and delivery to ensure your shipment arrives promptly.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/we-ship-it-for-you.svg',
        alt: 'We Ship It for You service'
      }
    }
  ]
}

export const whatWeShipSectionContent = {
  title: 'What We Ship: A Solution for Every Need',

  cards: [
    {
      id: 1,
      title: 'Luggage and Suitcases',
      description:
        'Travel stress-free by shipping your luggage ahead of time. Whether it’s a carry-on, duffel bag, or checked suitcase, we handle it all so you can skip long lines and baggage fees.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/luggage-and-suitcases.svg',
        alt: 'Luggage and Suitcases service'
      }
    },
    {
      id: 2,
      title: 'Sports Equipment',
      description:
        'Ship oversized items like golf clubs, skis, snowboards, and bikes without the hassle. Avoid expensive airline fees and travel light while we deliver your gear safely.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/sports-equipment.svg',
        alt: 'Sports Equipment service'
      }
    },
    {
      id: 3,
      title: 'Moving Boxes',
      description:
        'Relocating? Ship small furniture, packed boxes, and household essentials. Perfect for moving between homes, apartments, or across cities and countries.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/moving-boxes.svg',
        alt: 'Moving Boxes service'
      }
    },
    {
      id: 4,
      title: 'College Student Essentials',
      description:
        'Students can send their dorm supplies, study materials, and personal belongings to and from campus with ease. Affordable rates make this perfect for seasonal moves.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/college-student-essentials.svg',
        alt: 'College Student Essentials service'
      }
    },
    {
      id: 5,
      title: 'Business Shipments',
      description:
        'From office materials and trade show supplies to products and documents, ShipAndStorage ensures smooth and efficient shipping for businesses of all sizes.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/business-shipments.svg',
        alt: 'Business Shipments service'
      }
    },
    {
      id: 6,
      title: 'Fragile and Special Items',
      description:
        'We ship antiques, artwork, fragile goods, and valuables with extra care. Our expert handling and protective packing ensure they arrive in perfect condition.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/fragile-and-special-items.svg',
        alt: 'Fragile and Special Items service'
      }
    }
  ]
}

export const whyWeSectionContent = {
  title: 'Why Choose ShipAndStorage?',

  cards: [
    {
      id: 1,
      title: 'Secure and Reliable Shipping',
      description: 'Your items are handled with care from pickup to delivery, ensuring safety at every step.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/secure-and-reliable-shipping.svg',
        alt: 'Secure and Reliable Shipping service'
      }
    },
    {
      id: 2,
      title: 'Worldwide Coverage',
      description: 'We ship to over 220 countries and territories, making global shipping convenient.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/worldwide-coverage.svg',
        alt: 'Worldwide Coverage service'
      }
    },
    {
      id: 3,
      title: 'Affordable Rates',
      description: 'Save up to 70% compared to traditional carriers without sacrificing quality or reliability.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/affordable-rates.svg',
        alt: 'Affordable Rates service'
      }
    },
    {
      id: 4,
      title: 'Pickup and Drop-Off',
      description: 'Enjoy door-to-door service or drop your items at one of thousands of partner locations.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/pickup-and-drop-off.svg',
        alt: 'Pickup and Drop-Off service'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'Specialized Shipping for Unique Needs',

  cards: [
    {
      id: 1,
      title: 'Travelers and Tourists',
      description:
        'Simplify your trip by shipping luggage, gear, and souvenirs to your destination. Travel light and focus on enjoying your journey.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/travelers-and-tourists.svg',
        alt: 'Travelers and Tourists service'
      }
    },
    {
      id: 2,
      title: 'Athletes and Sports Enthusiasts',
      description:
        'Don’t let oversized sports equipment slow you down. Ship your golf clubs, bikes, or skis securely to events, competitions, or vacations.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/athletes-and-sports-enthusiasts.svg',
        alt: 'Athletes and Sports Enthusiasts service'
      }
    },
    {
      id: 3,
      title: 'Families Relocating or Moving',
      description:
        'Make moving simple with our shipping services for boxes, small furniture, and household goods. We handle the heavy lifting for you.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/families-relocating-or-moving.svg',
        alt: 'Families Relocating or Moving service'
      }
    },
    {
      id: 4,
      title: 'College Students',
      description:
        'Ship seasonal essentials, dorm supplies, or study materials to and from campus affordably and reliably.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/college-students.svg',
        alt: 'College Students service'
      }
    },
    {
      id: 5,
      title: 'Businesses and Professionals',
      description:
        'From trade show displays to office materials, we provide tailored solutions for corporate shipping needs.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/businesses-and-professionals.svg',
        alt: 'Businesses and Professionals service'
      }
    },
    {
      id: 6,
      title: 'Event Planners and Exhibitors',
      description:
        'Ensure your event materials and displays arrive on time and in great condition. We simplify shipping for trade shows and events.',
      image: {
        src: '/images/v2/pages/main-pages/what-we-ship/event-planners-and-exhibitors.svg',
        alt: 'Event Planners and Exhibitors service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Ship Your Items with Confidence',
  description:
    'No matter what you need to ship, ShipAndStorage makes it fast, simple, and cost-effective. From luggage and household goods to fragile or oversized items, we ensure reliable delivery every time.',
  image: {
    src: '/images/v2/pages/main-pages/what-we-ship/promotional-banner-image.svg',
    alt: 'Ship Your Items with Confidence'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Ship Easy' }
}

export const faqSectionContent = {
  title: 'Have Questions? Here Are the Answers',

  questions: [
    {
      id: 1,
      question: 'What types of items can I ship with ShipAndStorage?',
      answer:
        'We ship luggage, sports equipment, household items, fragile goods, and business materials securely and efficiently.'
    },
    {
      id: 2,
      question: 'Can you handle fragile or valuable items?',
      answer:
        'Yes, we specialize in shipping fragile and valuable items like antiques, artwork, and glassware with extra care and protection.'
    },
    {
      id: 3,
      question: 'Is there a weight or size limit for items you ship?',
      answer: 'We accommodate most standard weights and sizes. Contact us for shipping oversized or special items.'
    },
    {
      id: 4,
      question: 'Can I ship items internationally?',
      answer: 'Absolutely! We provide worldwide shipping services to over 220 countries and territories.'
    },
    {
      id: 5,
      question: 'What happens if my shipment is delayed or damaged?',
      answer: 'We offer shipping insurance options for added protection and work quickly to resolve any issues.'
    }
  ]
}
